import React from "react";

import AdminShell from "./AdminShell";

export default function ComingSoonAdminPage({ title, subtitle }) {
  return (
    <AdminShell title={title} subtitle={subtitle}>
      <section className="td-card reveal" style={{ "--delay": ".08s", padding: 20 }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Coming soon</div>
        <div style={{ color: "var(--muted, #b8b3aa)" }}>This section is not wired yet.</div>
      </section>
    </AdminShell>
  );
}
